import cmd from './lib/cmd'
import git from './lib/git'
import log from './lib/log'

async function choose() {
  const branches = git.getBranchesSync()
  let currentIndex = -1
  branches.forEach((name, i) => {
    if (name.match(/^\* /) !== null) {
      currentIndex = i
    }
  })
  const options = [{
    type: 'list',
    name: 'name',
    message: 'What branch do you want to checkout?',
    choices: branches,
    default: currentIndex,
  }]
  const answers = await cmd.prompt(options)
  return answers.name.replace(/\* /, '')
}

async function branch() {
  const name = await choose()
  cmd.execSync(`git checkout ${name}`, { stdio: 'inherit' })
}

export default () => {
  branch().catch(log.catchError)
}
